import React, { FC } from "react";
import { Button, TitleHeader } from "@xapp/components";
import { OrgAnalyticsContainer } from "components/OrgAnalytics/components/OrgAnalyticsContainer";
import { Link } from "react-router-dom";

export interface OrgRecentAnalyticsProps {
    readonly organizationId: string;
    readonly endDate: Date;
    readonly startDate: Date;
}

export const OrgRecentAnalytics: FC<OrgRecentAnalyticsProps> = ({
    organizationId,
    endDate,
    startDate
}: OrgRecentAnalyticsProps) => {

    const analyticsPath = `/${organizationId}/analytics`;

    return (
        <>
            <TitleHeader value="Last 7 Days" static>
                <Link to={analyticsPath}>
                    <Button variation="secondary" leftIcon="trending_up" label="View Analytics" />
                </Link>
            </TitleHeader>
            <OrgAnalyticsContainer
                organizationId={organizationId}
                startDate={startDate}
                endDate={endDate}
                embedded={true}
            />
        </>
    );
};
